import React, { FC, useMemo, useRef } from "react";
import { FlatList, ScrollView } from "react-native";
import { View, Spinner } from "@lookiero/aurora";
import { Column, Row, Layout as UiLayout, useScreenSize } from "@lookiero/sty-psp-ui";
import { Order } from "../../../../../domain/entities/order/Order";
import { OrdersHeader } from "../header/ordersHeader/OrdersHeader";
import { Layout } from "../layout/Layout";
import { style as ordersStyle } from "./Orders.styles";
import { NoOrders } from "./noOrders/NoOrders";
import { OrderCard } from "./orderCard/OrderCard";

interface OrdersProps {
  readonly layout: UiLayout;
  readonly orders: Order[];
  readonly isLoading: boolean;
  readonly onBack: () => void;
  readonly formatDate: (date: string) => string;
}

const Orders: FC<OrdersProps> = ({ layout, orders, onBack, isLoading, formatDate }) => {
  const screenSize = useScreenSize();
  const scrollRef = useRef<ScrollView>(null);
  const thereAreOrders = Boolean(orders?.length);

  const style = useMemo(() => ordersStyle(), []);

  return (
    <Layout footer={null} header={<OrdersHeader onBack={onBack} />} layout={layout} scrollRef={scrollRef}>
      {isLoading ? (
        <View style={style.spinnerWrapper}>
          <Spinner />
        </View>
      ) : (
        <Row style={[style.row, screenSize !== "L" && style.smallRow]}>
          <Column size={{ L: "2/3" }}>
            {thereAreOrders ? (
              <View style={[style.ordersWrapper, screenSize === "L" && style.ordersWrapperLarge]}>
                <FlatList
                  data={orders}
                  keyExtractor={(item) => item.orderId}
                  renderItem={({ item: order }) => <OrderCard formatDate={formatDate} order={order} />}
                />
              </View>
            ) : (
              <NoOrders />
            )}
          </Column>
        </Row>
      )}
    </Layout>
  );
};

export { Orders };
